import { Injectable } from '@angular/core';

import { WinGameFixture, WinGameFixturePreview } from '@frontend/sports/racing/feature/models';
import { flatten, keyBy } from 'lodash-es';

import { Promotion } from '../../crm-offer-data/crm-offer.model';

@Injectable()
export class CrmPromotionMapperService {
    getBannerPromotions(fixture: WinGameFixturePreview | WinGameFixture, promotions: Promotion[]): Promotion[] {
        const promos = promotions.filter((p) => !!p.banner);
        if (!promos.length) {
            return [];
        }

        const optionMap = isFullFixture(fixture) ? keyBy(flatten(fixture.participants.map((p) => p.options)).map((o) => o.id)) : {};

        return promos.filter((promotion) => {
            return promotion.allFilters.some((filter) => {
                if (filter.fixtureIds.some((fId) => fId === fixture.id)) {
                    return true;
                }

                if (filter.meetingIds.some((mId) => fixture.fixtureGroup && mId === fixture.fixtureGroup.id)) {
                    return true;
                }

                if (filter.optionIds.some((oId) => !!optionMap[oId])) {
                    return true;
                }

                return false;
            });
        });
    }

    getMeetingPromotions(fixture: WinGameFixturePreview | WinGameFixture, promotions: Promotion[]): Promotion[] {
        const promos = promotions.filter((p) => !!p.banner);
        if (!promos.length) {
            return [];
        }

        return promotions.filter((p) => p.banner && p.allFilters.some((f) => f.meetingIds.some((id) => id === fixture.meeting.id)));
    }
}

function isFullFixture(fixture: WinGameFixturePreview | WinGameFixture): fixture is WinGameFixture {
    return !!(fixture as WinGameFixture).participants;
}
